export function formatCurrency(amount: number | string) {
  const value = Math.floor(parseFloat(amount.toString()));

  return value.toLocaleString("vi-VN", {
    style: "currency",
    currency: "VND",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}
